import Repository from "./Repository";
const resource = "/api/v1/clubcoach/";
export default {
  getClubCoach(id) {
    let subUrl = `${resource}getClubHeadCoach/${id}`;
    return Repository.sendReq({ method: "get", subUrl });
  },
  getClubsProfile(id) {
    let subUrl = `/api/v1/club/getone/${id}`;
    return Repository.sendReq({ method: "get", subUrl });
  }
};
